import React, {useContext, useEffect, useState} from 'react'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
// import './sandbox-chat.scss'
import './sandbox-chat-v2.scss'
import SandBoxContext from '../../../contexts/SandBoxContext'
import { FlowButton } from '../../../components/flow-ui/flow-blocks'
import { quotationCleaner, urlFormatter, normalizeMathDelimiters, parseMarkdownLinks, parseMarkdownImages } from '../../../utilities/input-formatter'
import reactStringReplace from 'react-string-replace'
import Previewer from '../../../components/previewer/previewer'
import remarkMath from 'remark-math'
import rehypeKatex from 'rehype-katex'
import 'katex/dist/katex.min.css'
import { detectEnclosedTag } from '../../../utilities/handyFunctions'
import ChatImages from '../../../components/chat-images'
import TaskProgress from '../../../components/loading-widget/task_progress'

// import IntroV2 from '../../../components/intro-v2/intro'

const SandBoxChat = () => {
  const { sandboxState } = useContext(SandBoxContext)
  const { prompts, testPrompts } = sandboxState
  var content = null
  var intro = null
  var padding = null
  if(sandboxState?.metadata?.promptTesting?.enabled === true) {
    content = [...testPrompts]
  } else {
    content = [...prompts]
  }
  let numOfContents = content?.length ?? 0
  if(numOfContents > 0) {
    padding = <div style={{flexGrow: 1}}></div>
    content.reverse()
    content = content.map((c, i) => <SandBoxConvoBlock key={(numOfContents - i)} role={c.role} content={c.content} reference={c?.reference} extra={c?.extra || null}/>)
  } else {
    intro = <BasicIntro/>
    // intro = <IntroV2/>
  }
  return (
    <div className='sndbx-chat-container' style={{paddingLeft: '10px'}}>
      <div className='sndbx-content-body' style={{display: 'flex', flexDirection: 'column-reverse'}}>
        {intro}
        {content}
        {padding}
      </div>
    </div>
  )
}

export default SandBoxChat

const BasicIntro = () => {
  const {sandboxState} = useContext(SandBoxContext)
  var testMode = null
  if(sandboxState?.metadata?.promptTesting?.enabled === true) {
    testMode = <><FlowButton style={{marginLeft: '10px', marginBottom: '3px', filter: 'brightness(100%)', fontWeight: 700, color: 'orange'}}>Test Mode</FlowButton></>
  }
  return (
    <div className='sndbx-intro'>
      <div style={{paddingLeft: '10px'}}>
        <div style={{display: 'flex', alignItems: 'flex-end'}}>
          I am Nelima{testMode}
        </div>
        <span style={{fontSize: '14px', fontWeight: 500}}>The General Agentic AI.</span>
      </div>
    </div>
  )
}

const SandBoxConvoBlock = ({role, content, reference, extra=null}) => {
  if(reference) {
    return <>
      <SandBoxAssistantBlock content={content} extra={extra}/>
      <SandBoxUserBlockReply content={reference}/>
      <div style={{marginTop: '15px'}}></div>
    </>
  }
  if(role === 'assistant') {
    return <SandBoxAssistantBlock content={content} extra={extra}/>
  }
  else if(role === 'user') return <SandBoxUserBlock content={content}/>
}

const SandBoxUserBlock = ({content=''}) => {
  let formattedContent = reactStringReplace(content, /(https?:\/\/[^\s]+)/g, urlFormatter)
  return (
    <div className='sndbx-convo-base sndbx-convo-user'>
      {/* <div style={{minWidth: '16px', marginRight: '8px', fontSize: '16px', lineHeight: 1}}>
        <i className="fas fa-quote-left"></i>
      </div> */}
      <div className='quote-blk'><i className="fas fa-quote-left"></i></div>
      {formattedContent}
    </div>
  )
}

const SandBoxUserBlockReply = ({content=''}) => {
  const result = detectEnclosedTag(content, 'DEPLOYED_TASK')
  let formattedContent = reactStringReplace(result.content, /(https?:\/\/[^\s]+)/g, urlFormatter)
  if(result.isEnclosed === true) {
    var iconContent = <i className="fas fa-tasks" style={{marginTop: '5px', color: 'orange'}}></i>
  } else {
    iconContent = <i className="fas fa-clock" style={{marginTop: '5px', color: 'orange'}}></i>
  }
  return (
    <div className='sndbx-convo-base sndbx-convo-user'>
      <div className='sndbx-convo-rply'>
        <div className='rply-smbl'></div>
        &nbsp;&nbsp;Nelima replied to You
      </div>
      <div className='quote-blk'>{iconContent}</div>
      {formattedContent}
    </div>
  )
}

const PreviewerCarousel = ({ fileLinks }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  if (!fileLinks || fileLinks.length === 0) return null

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? fileLinks.length - 1 : prev - 1))
  }

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === fileLinks.length - 1 ? 0 : prev + 1))
  }

  const currentLink = fileLinks[currentIndex]

  return (
    <div className='previewer-carousel'>
      {fileLinks.length > 1 && (
        <div className='carousel-header'>
          <div className='carousel-label'>
            <i className="far fa-file-alt"></i>
            <span>{currentLink.label}</span>
          </div>
          <div className='carousel-nav'>
            <div className='carousel-btn' onClick={handlePrev}>
              <i className="fas fa-chevron-left"></i>
            </div>
            <div className='carousel-counter'>
              {currentIndex + 1}<span>/{fileLinks.length}</span>
            </div>
            <div className='carousel-btn' onClick={handleNext}>
              <i className="fas fa-chevron-right"></i>
            </div>
          </div>
        </div>
      )}
      <Previewer
        key={`viewer-${currentLink.href}-${currentIndex}`}
        label={currentLink.label}
        href={currentLink.href}
      />
    </div>
  )
}

const SandBoxAssistantBlock = ({content='', isEdited=false, extra=null }) => {
  const [isCopied, setIsCopied] = useState(false)
  const [fileLinks, setFileLinks] = useState([])
  const [images, setImages] = useState([])
  
  useEffect(() => {
    const links = document.querySelectorAll('.markdown-wrapper a')
    links.forEach(link => {
      link.setAttribute('target', '_blank')
      link.setAttribute('rel', 'noopener noreferrer')
    })
  }, [])

  useEffect(() => {
    const links = parseMarkdownLinks(content)
    const imgs = parseMarkdownImages(content)
    setFileLinks(links)
    setImages(imgs)
  }, [content])

  const handleCopy = () => {
    if(!isCopied) {
      navigator.clipboard.writeText(content).then(() => {
        setIsCopied(true)
        setTimeout(() => {
          if(setIsCopied) setIsCopied(false)
        }, 2000)
      }).catch(err => {
        console.log('Error copying to clipboard')
      })
    }
  }

  return (
    <div className='sndbx-convo-base sndbx-convo-assistant'>
      <div className='convo-control'>
        {isCopied ? 
          <i className="far fa-check ctrl-btn"></i>
          :
          <i className="far fa-clipboard ctrl-btn"
            onClick={handleCopy}
          ></i>
        }
      </div>
      <Markdown 
        className='markdown-wrapper'
        remarkPlugins={[remarkGfm, [remarkMath, { singleDollarTextMath: false }]]}
        rehypePlugins={[rehypeKatex]}
        components={{
          img: ({ src, alt }) => (
            <a 
              href={src} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {alt || 'View image'}
            </a>
          )
        }}
      >
        {normalizeMathDelimiters(quotationCleaner(content))}
      </Markdown>
      <ChatImages images={images}/>
      { fileLinks.length > 0 && (
        <div className='markdown-wrapper'>
          <PreviewerCarousel fileLinks={fileLinks} />
        </div>
      )}
      {
        extra?.jobID && (
          <TaskProgress processID={extra?.jobID} finishedAt={extra?.finishedAt || null} pausedAt={extra?.pausedAt || null} fileDetails={extra?.files || []}/>
        )
      }
    </div>
  )
}